const members = {
  clement: {
    position: "Managing partner",
    text: "A 3D development engineer specialized in mobile technologies since 2010, Clément founded CDO Apps in 2016.<br /><br />He is responsible for the quality of the applications developed by the studio.",
  },
  lydie: {
    position: "Partner and project manager",
    text: "An embedded systems engineer, Lydie is co-founder of CDO Apps.<br /><br />She manages projects and client relationships, tracking development progress and deliverable quality.",
  },
  romuald: {
    position: "Developer",
    text: "A robotics engineer, Romuald specializes in iOS app development and joined CDO Apps in 2020.<br /><br />Flutter has become his preferred tool for cross-platform development.",
  },
  vincent: {
    position: "Developer",
    text: "A video game developer, Vincent joined us in 2019.<br /><br />His Unity development and game design expertise is a strong asset for mobile game projects and interactive experiences.",
  },
  marion: {
    position: "Art director",
    text: "A graphic designer and illustrator, Marion is our partner for creating the visual identity of your applications.<br /><br />She designs the interfaces and graphic elements for our projects.",
  },
  uriel: {
    position: "2D/3D animator",
    text: "With his animation expertise, Uriel brings movement and life to your projects.",
  },
  maxime: {
    position: "Sound designer",
    text: "Maxime is a composer and sound designer specialized in creating audio assets for video games.<br /><br />We work with him to enrich the sound experience of our applications.",
  },
};

export default members;
